import React from 'react';
import './Controls.css';
import { isBoolean } from 'lodash';
import { getControlStyle } from '../helper';

export function TextInput(props) {
  const { placeHolder, rowIndex, colIndex, charCount, maxCount, onChange, CustomAddEditAccess, otherConfiguration, isProductArchived } = props;
  const combinedStyles = getControlStyle(otherConfiguration);
  return (
    <div className="input-group form-floating-label-po p-0 mb-0 fixed-label">
      <label />
      <input
        type="text"
        placeholder={placeHolder}
        className="form-control"
        value={props?.value || ''}
        autoComplete="off"
        style={combinedStyles}
        maxLength={maxCount}
        disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
        onChange={(e) => onChange(e.target.value, rowIndex, colIndex)}
      />

      {charCount && (
        <div className="text-count">
          {props?.value?.length || 0}/{maxCount}
        </div>
      )}
    </div>
  );
}

export default TextInput;
